var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-lg" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-12 col-md-4 mt-3" }, [
        _c("div", { staticClass: "card" }, [
          _c(
            "div",
            {
              staticClass: "card-body text-center",
              staticStyle: { cursor: "pointer" },
              on: {
                click: function ($event) {
                  return _vm.PushTo("/companymydata")
                },
              },
            },
            [
              _c("fa", {
                staticClass: "fa-5x",
                staticStyle: { color: "#bc0101" },
                attrs: { icon: "file-pen" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "text-center" }, [
            _vm._v("Eingabe Firmendaten"),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-12 col-md-4 mt-3" }, [
        _c("div", { staticClass: "card" }, [
          _c(
            "div",
            {
              staticClass: "card-body text-center",
              staticStyle: { cursor: "pointer" },
              on: {
                click: function ($event) {
                  return _vm.PushTo("/companymydata")
                },
              },
            },
            [
              _c("fa", {
                staticClass: "fa-5x",
                staticStyle: { color: "#bc0101" },
                attrs: { icon: "building-user" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "text-center" }, [
            _vm._v("Jobs bearbeiten"),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-12 col-md-4 mt-3" }, [
        _c("div", { staticClass: "card" }, [
          _c(
            "div",
            {
              staticClass: "card-body text-center",
              staticStyle: { cursor: "pointer" },
              on: {
                click: function ($event) {
                  return _vm.logout()
                },
              },
            },
            [
              _c("fa", {
                staticClass: "fa-5x",
                staticStyle: { color: "#bc0101" },
                attrs: { icon: "right-from-bracket" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "text-center" }, [_vm._v("App verlassen!")]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }